import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Tab, Tabs } from '@blueprintjs/core';
import { css } from '@emotion/react';
import { memo } from 'react';
import { SignalJCouplingsTable } from './signal-tabs/SignalJCouplingsTable';
import { SignalPeaksTable } from './signal-tabs/SignalPeaksTable';
const style = {
    borderSpacing: '0',
    width: '100%',
    fontSize: '12px',
    height: '100%',
    margin: '0',
    padding: '0.4rem',
    textAlign: 'center',
};
function SignalTab({ index }) {
    return (_jsx("div", { style: style, css: css `
        div[role='tabpanel'] {
          width: 100%;
        }
      `, children: _jsxs(Tabs, { vertical: true, fill: true, renderActiveTabPanelOnly: true, children: [_jsx(Tab, { id: "couplings", title: "Couplings", panel: _jsx(SignalJCouplingsTable, { index: index }) }), _jsx(Tab, { id: "peaks", title: "Peaks", panel: _jsx(SignalPeaksTable, { index: index }) })] }) }));
}
export default memo(SignalTab);
